import { BrowseSearchQueryParams, BrowseSearchResults } from '../types';
import apiRequest from './apiRequest';

export default async function postBrowseSearch(
  params: BrowseSearchQueryParams,
  signal?: AbortSignal,
) {
  const { data, error } = await apiRequest<BrowseSearchResults>(
    'mogen-orchestration',
    '/browseSearch',
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    signal,
  );
  return { data, error };
}
